import { AxiosError } from "axios";

const STATUS_MESSAGES: Record<number, string> = {
  401: "Sua sessão expirou. Entre novamente para continuar.",
  403: "Você não tem permissão para fazer esta ação.",
  404: "O item não foi encontrado. Ele pode ter sido removido.",
  413: "O arquivo é grande demais para ser enviado.",
};

export const getApiErrorMessage = (error: unknown, fallbackMessage: string): string => {
  if (!(error instanceof AxiosError)) return fallbackMessage;

  if (!error.response) return "Não foi possível conectar ao servidor. Verifique sua conexão e tente novamente.";

  const message: unknown = error.response.data?.message;

  if (typeof message === "string" && message.trim()) return message;
  if (Array.isArray(message) && typeof message[0] === "string") return message[0];

  const { status } = error.response;

  if (STATUS_MESSAGES[status]) return STATUS_MESSAGES[status];
  if (status >= 500) return "O servidor não conseguiu concluir a ação. Tente novamente em instantes.";

  return fallbackMessage;
};
